import React from "react";
import { IconType } from "react-icons";
import { Link } from "react-router-dom";
import styles from "./NavButton.module.scss";

interface NavButtonProps {
  icon: IconType;
  onClick?: () => void;
  to?: string;
  label: string;
  isActive?: boolean;
  variant: "desktop" | "mobile";
}

export default function NavButton({
  icon: Icon,
  onClick,
  to,
  label,
  isActive = false,
  variant,
}: NavButtonProps) {
  const className = `${styles.navButton} ${styles[variant]} ${isActive ? styles.active : ""}`;

  const content = (
    <>
      <Icon size={24} />
      {variant === "desktop" && <span className={styles.label}>{label}</span>}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={className} aria-label={label}>
        {content}
      </Link>
    );
  }

  return (
    <button className={className} onClick={onClick} aria-label={label}>
      {content}
    </button>
  );
}
